import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { FaSearch, FaUser, FaCaretDown, FaShoppingCart } from "react-icons/fa";
import Flex from "../../designLayouts/Flex";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { paginationItems } from "../../../constants";

const HeaderBottom = () => {
  const products = useSelector((state) => state.orebiReducer.products);
  const [show, setShow] = useState(false);
  const [showUser, setShowUser] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [showMore, setShowMore] = useState(false); 
  const navigate = useNavigate();
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setShow(false);
        setShowUser(false);
      }
    };

    document.body.addEventListener("click", handleClickOutside);
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    if (searchQuery) {
      const queryLower = searchQuery.toLowerCase();
      
      const getMatchScore = (productName, color) => {
        let score = 0;
        
        if (productName.toLowerCase().includes(queryLower)) score += 2;  
        if (color && color.toLowerCase().includes(queryLower)) score += 1; 
        
        return score;
      };

      const filtered = paginationItems
        .map((item) => {
          const matchScore = getMatchScore(item.productName, item.color);
          if (matchScore > 0) {
            return { ...item, matchScore }; 
          }
          return null;
        })
        .filter((item) => item !== null)
        .sort((a, b) => b.matchScore - a.matchScore); 

      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }
  }, [searchQuery]);

  const handleShowMore = () => {
    setShowMore(true);  
  };

  return (
    <div className="w-full bg-[#F5F5F3] relative">
      <div className="max-w-container mx-auto">
        <Flex className="flex flex-col lg:flex-row items-start lg:items-center justify-between w-full px-4 pb-4 lg:pb-0 h-full lg:h-24">
          <div
            onClick={() => setShow((prev) => !prev)}
            ref={ref}
            className="flex h-14 cursor-pointer items-center gap-2 text-primeColor"
          >
            <HiOutlineMenuAlt4 className="w-5 h-5" />
            <p className="text-[14px] font-normal">Shop by Category</p>

            {show && (
              <motion.ul
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="absolute top-36 z-50 bg-primeColor w-auto text-[#767676] h-auto p-4 pb-6"
              >
                {[{ name: "Fans", link: "/products/fans" }, { name: "AC", link: "/products/ac" }, { name: "Geyser", link: "/products/geyser" }, { name: "Refrigerator", link: "/products/refrigerator" }, { name: "Dispenser", link: "/products/dispenser" }, { name: "All Products", link: "/shop" }].map((item, index) => (
                  <Link key={index} to={item.link}>
                    <li className="text-gray-400 px-4 py-1 border-b-[1px] border-b-gray-400 hover:border-b-white hover:text-white duration-300 cursor-pointer">
                      {item.name}
                    </li>
                  </Link>
                ))}
              </motion.ul>
            )}
          </div>

          <div className="relative w-full lg:w-[600px] text-base text-primeColor bg-white flex items-center gap-2 justify-between px-6 rounded-xl">
            <input
              className="flex-1 outline-none placeholder:text-[#C4C4C4] placeholder:text-[14px] py-3"
              type="text"
              onChange={handleSearch}
              value={searchQuery}
              placeholder="Search your products here"
            />
            <FaSearch className="w-5 h-5" />
            {searchQuery && (
              <div className="w-full mx-auto bg-white top-16 absolute left-0 z-10 overflow-y-auto shadow-2xl scrollbar-hide cursor-pointer">
                {filteredProducts.length > 0 ? (
                  <>
                    {filteredProducts.slice(0, 5).map((item) => (
                      <div
                        key={item._id}
                        onClick={() => {
                          navigate(`/product/${item.productName.toLowerCase().split(" ").join("")}`, {
                            state: { item: item },
                          });
                          setSearchQuery("");
                        }}
                        className="max-w-[600px] py-4 px-3 bg-gray-100 mb-3 flex items-center gap-3"
                      >
                        <img className="w-24" src={item.img} alt="productImg" />
                        <div className="flex flex-col gap-1">
                          <p className="font-semibold text-lg">{item.productName}</p>
                          <p className="text-xs">{item.color}</p> 
                          <p className="text-sm">
                            Price: <span className="text-primeColor font-semibold">Rs.{item.price}</span>
                          </p>
                        </div>
                      </div>
                    ))}
                    {!showMore && (
                      <div
                        onClick={handleShowMore}
                        className="text-primeColor cursor-pointer text-center py-2"
                      >
                        Show More
                      </div>
                    )}
                    {showMore && (
                      filteredProducts.map((item) => (
                        <div
                          key={item._id}
                          onClick={() => {
                            navigate(`/product/${item.productName.toLowerCase().split(" ").join("")}`, {
                              state: { item: item },
                            });
                            setSearchQuery("");
                          }}
                          className="max-w-[600px] py-4 px-3 bg-gray-100 mb-3 flex items-center gap-3"
                        >
                          <img className="w-24" src={item.img} alt="productImg" />
                          <div className="flex flex-col gap-1">
                            <p className="font-semibold text-lg">{item.productName}</p>
                            <p className="text-xs">{item.des}</p>
                            <p className="text-sm">
                              Price: <span className="text-primeColor font-semibold">Rs.{item.price}</span>
                            </p>
                          </div>
                        </div>
                      ))
                    )}
                  </>
                ) : (
                  <p className="text-gray-400 py-2 text-center">No products found</p>
                )}
              </div>
            )}
          </div>

          <div className="flex gap-4 mt-2 lg:mt-0 items-center pr-6 cursor-pointer relative">
            <div onClick={() => setShowUser((prev) => !prev)} className="flex">
              <FaUser />
              <FaCaretDown />
            </div>
            {showUser && (
              <motion.ul
                initial={{ y: 30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="absolute top-6 left-0 z-50 bg-primeColor w-44 text-[#767676] h-auto p-4 pb-6"
              >
                <Link to="/signin">
                  <li className="text-gray-400 px-4 py-1 border-b-[1px] border-b-gray-400 hover:border-b-white hover:text-white duration-300 cursor-pointer">
                    Login
                  </li>
                </Link>
                <Link to="/signup" onClick={() => setShowUser(false)}>
                  <li className="text-gray-400 px-4 py-1 border-b-[1px] border-b-gray-400 hover:border-b-white hover:text-white duration-300 cursor-pointer">
                    Sign Up
                  </li>
                </Link>
                <li className="text-gray-400 px-4 py-1 border-b-[1px] border-b-gray-400 hover:border-b-white hover:text-white duration-300 cursor-pointer">
                  Profile
                </li>
                <li className="text-gray-400 px-4 py-1 border-b-[1px] border-b-gray-400 hover:border-b-white hover:text-white duration-300 cursor-pointer">
                  Others
                </li>
              </motion.ul>
            )}
            <Link to="/cart">
              <div className="relative">
                <FaShoppingCart />
                <span className="absolute font-titleFont top-3 -right-2 text-xs w-4 h-4 flex items-center justify-center rounded-full bg-primeColor text-white">
                  {products.length > 0 ? products.length : 0}
                </span>
              </div>
            </Link>
          </div>
        </Flex>
      </div>
    </div>
  );
};

export default HeaderBottom;
